export const experienceData = [
    {
        id: 1,
        company: 'Assured Techmatics · Apollo ELD',
        location: 'Knoxville, TN, USA',
        jobtitle: 'Director of Technology',
        startYear: 'Aug 2024',
        endYear: 'Present',
        description: 'Lead the engineering organization behind a U.S. federally registered ELD platform serving 100,000+ commercial vehicles, 2,000+ integrations, and 200+ resellers.',
        highlights: [
            'Architected the webhook delivery platform, FMCSA signing-certificate lifecycle, and compliance-grounded RAG AI support agent now running in production.',
            'Built and led FreightExpeditor, a freight-broker capacity-intelligence platform, end-to-end.',
            'Named on the U.S. DOT FMCSA federal registry as the platform’s authorized technical maintainer.',
            'Mentor engineers, own system-design reviews, coding standards, and cloud-security & regulatory compliance.',
        ],
    },
    {
        id: 2,
        company: 'Wenable Inc.',
        location: 'USA',
        jobtitle: 'Technical Lead',
        startYear: 'Jan 2023',
        endYear: 'Jul 2024',
        description: 'Led engineering across SaaS products for fleet intelligence, MDM/UEM, and real-time tracking.',
        highlights: [
            'Drove architecture and delivery across multiple embedded product lines and cross-functional teams.',
            'Owned device-to-cloud communication, event pipelines, and enterprise-grade reliability.',
        ],
    },
    {
        id: 3,
        company: 'Wenable Technologies · PoLTE (acq. Qualcomm) · M2M In Motion (acq. AAMP Global) · WeGuard',
        location: 'India & USA',
        jobtitle: 'Senior Software Engineer / Module Owner',
        startYear: 'Jun 2019',
        endYear: 'Aug 2021',
        description: 'Core engineer on platforms later acquired by Qualcomm and AAMP Global, and on the Android Enterprise Gold-certified WeGuard MDM platform.',
        highlights: [
            'PoLTE (acquired by Qualcomm): built Go + gRPC microservices for the patented 4G/5G positioning data pipeline on Kubernetes/AWS.',
            'M2M In Motion (acquired by AAMP Global): designed high-volume device-to-cloud telemetry, webhook integrations, and geospatial reporting.',
            'WeGuard: module owner for Apple MDM (iOS/iPadOS/macOS/tvOS); key contributor to Google Android Enterprise Gold partnership.',
        ],
    },
    {
        id: 4,
        company: 'Wenable Technologies Pvt. Ltd.',
        location: 'India',
        jobtitle: 'Software Engineer',
        startYear: 'Jun 2018',
        endYear: 'May 2019',
        description: 'Built backend microservices and APIs across the fleet and enterprise workflow product suite.',
        highlights: [],
    },
    {
        id: 5,
        company: 'Wenable Technologies Pvt. Ltd.',
        location: 'India',
        jobtitle: 'Associate Software Engineer',
        startYear: 'Jun 2017',
        endYear: 'May 2018',
        description: 'Began career building real-time tracking and alerts systems on a high-volume telematics platform.',
        highlights: [],
    },
    {
        id: 6,
        company: 'CodeTantra Tech Solutions Pvt. Ltd.',
        location: 'India',
        jobtitle: 'Software Intern',
        startYear: 'May 2015',
        endYear: 'Dec 2015',
        description: 'Early hands-on engineering experience in web application development.',
        highlights: [],
    },
]
